// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__gIN1j","textInput":"Input_textInput__CEa9T","colorInput":"Input_colorInput__jgxEA","ghost":"Input_ghost__FTqTS"};